<p-card
  styleClass="bg-zinc-900 border border-zinc-700"
  class="office-file-card w-full"
>
  <ng-template pTemplate="header">
    <div
      class="flex items-center justify-between px-3 py-2 bg-zinc-800 rounded-t-lg"
    >
      <div class="flex items-center">
        <i class="pi pi-book text-primary mr-2"></i>
        <h3 class="text-base font-medium m-0">Fiche bureau</h3>
      </div>
    </div>
  </ng-template>

  <div class="p-2">
    <!-- Loading state -->
    <div *ngIf="loading" class="flex justify-center items-center py-2">
      <p-progressSpinner
        [style]="{ width: '24px', height: '24px' }"
      ></p-progressSpinner>
    </div>

    <!-- No data state -->
    <div
      *ngIf="!loading && !fullAffairDetails"
      class="text-center text-zinc-400 text-xs py-1"
    >
      <i class="pi pi-info-circle mr-1"></i>
      Aucune fiche bureau
    </div>

    <!-- Content -->
    <div *ngIf="!loading && fullAffairDetails" class="office-file-content">
      <!-- Row 1: Indicateurs -->
      <div *ngIf="hasIndicators" class="flex items-center gap-1 flex-wrap mb-2">
        <span class="text-[10px] text-zinc-500 mr-1 shrink-0">
          <i class="pi pi-chart-bar"></i> Indicateurs:
        </span>
        <span
          *ngFor="let indicator of indicators"
          class="indicator-badge text-[10px] px-1.5 py-0.5 rounded"
          [ngClass]="indicator.pivot.value === 0 ? 'danger' : 'success'"
          [pTooltip]="indicator.name"
          tooltipPosition="top"
        >
          {{ indicator.name | slice: 0 : 20
          }}{{ indicator.name.length > 20 ? '..' : '' }}
        </span>
      </div>

      <!-- Row 2: Paramètres d'envoi - Grid layout -->
      <div *ngIf="hasSendSettings" class="send-settings-container">
        <div class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
          <div
            *ngFor="let setting of sendSettings"
            class="send-setting-card bg-zinc-800/50 rounded p-2 border border-zinc-700/50"
          >
            <!-- Header: Nom + Status -->
            <div class="flex items-center justify-between mb-1.5">
              <span class="text-[11px] font-medium text-zinc-300 truncate flex-1 mr-2">
                <i class="pi pi-send text-[10px] text-zinc-500 mr-1"></i>
                {{ setting.sendSetting.name }}
              </span>
              <span
                class="status-badge text-[9px] px-1.5 py-0.5 rounded shrink-0"
                [ngClass]="setting.isAutomaticSend === 1 ? 'active' : 'inactive'"
              >
                {{ setting.isAutomaticSend === 1 ? 'Auto' : 'Manuel' }}
              </span>
            </div>

            <!-- Destinataires TO -->
            <div *ngIf="getToRecipients(setting).length > 0" class="mb-1">
              <div class="text-[9px] text-zinc-500 mb-0.5">Destinataires:</div>
              <div class="flex flex-col gap-0.5">
                <a
                  *ngFor="let recipient of getToRecipients(setting)"
                  [href]="'mailto:' + recipient.email"
                  class="email-link to text-[10px] hover:text-blue-400 truncate block"
                  [title]="recipient.email"
                >
                  {{ recipient.email }}
                </a>
              </div>
            </div>

            <!-- Destinataires CC -->
            <div *ngIf="getCcRecipients(setting).length > 0">
              <div class="text-[9px] text-zinc-500 mb-0.5">En copie:</div>
              <div class="flex flex-col gap-0.5">
                <a
                  *ngFor="let recipient of getCcRecipients(setting)"
                  [href]="'mailto:' + recipient.email"
                  class="email-link cc text-[10px] hover:text-purple-400 truncate block"
                  [title]="recipient.email"
                >
                  {{ recipient.email }}
                </a>
              </div>
            </div>

            <!-- Aucun destinataire -->
            <span
              *ngIf="
                getToRecipients(setting).length === 0 &&
                getCcRecipients(setting).length === 0
              "
              class="text-[9px] text-zinc-500 italic"
            >
              Aucun destinataire
            </span>
          </div>
        </div>
      </div>

      <!-- Row 3: Warning email + Commentaire -->
      <div *ngIf="(affair && !affair.finalCustomerEmail) || comment" class="flex items-center gap-4 flex-wrap mt-2">
        <!-- Warning email -->
        <div
          *ngIf="affair && !affair.finalCustomerEmail"
          class="flex items-center gap-1 text-[10px] text-yellow-400"
        >
          <i class="pi pi-exclamation-triangle"></i>
          <span>Email client manquant</span>
        </div>

        <!-- Commentaire -->
        <div *ngIf="comment" class="flex items-center gap-1 flex-1 min-w-0">
          <i class="pi pi-comment text-[10px] text-zinc-500 shrink-0"></i>
          <span
            class="text-[10px] text-zinc-400 truncate"
            [pTooltip]="comment"
            tooltipPosition="top"
          >
            {{ comment | slice: 0 : 150
            }}{{ comment.length > 150 ? '...' : '' }}
          </span>
        </div>
      </div>

      <!-- Empty state -->
      <div
        *ngIf="!hasIndicators && !hasSendSettings && !comment"
        class="text-center text-zinc-500 text-[10px]"
      >
        Aucune information
      </div>
    </div>
  </div>
</p-card>
